import React from 'react';
import { FiMic } from 'react-icons/fi';

export const QuotedMessage = ({ replyTo, isFromCurrentUser, currentUserId, senderName }) => {
    if (!replyTo) return null;

    // Determine the sender name dynamically
    let senderDisplayName = "";
    if (replyTo.senderId === currentUserId) {
        senderDisplayName = "You";
    } else {
        senderDisplayName = senderName || "Unknown";
    }

    // Determine what to display
    let displayContent = null;

    if (replyTo.imageUrl) {
        displayContent = (
            <div className="flex items-center space-x-2">
                <img src={replyTo.imageUrl} alt="Replied to" className="w-8 h-8 rounded object-cover" />
                <span className={`text-sm ${isFromCurrentUser ? "text-white/75" : "text-gray-500 dark:text-gray-400"}`}>📷 Photo</span>
            </div>
        );
    } else if (replyTo.audioUrl) {
        displayContent = (
            <div className="flex items-center space-x-2">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center ${isFromCurrentUser ? "bg-white/20" : "bg-primary/10"}`}>
                    <FiMic className={`w-3 h-3 ${isFromCurrentUser ? "text-white" : "text-primary"}`} />
                </div>
                <span className={`text-sm ${isFromCurrentUser ? "text-white/75" : "text-gray-500 dark:text-gray-400"}`}>🎤 Voice message</span>
            </div>
        );
    } else if (replyTo.text) {
        displayContent = (
            <p className={`text-sm line-clamp-2 ${isFromCurrentUser ? "text-white/80" : "text-gray-600 dark:text-gray-300"}`}>
                {replyTo.text}
            </p>
        );
    }

    return (
        <div className={`p-2 rounded-md border-l-[3px] ${isFromCurrentUser
            ? "bg-black/20 border-white/50"
            : "bg-gray-100 dark:bg-black/20 border-primary"
        }`}>
            <p className={`text-xs font-semibold mb-0.5 ${isFromCurrentUser
                ? "text-white/90"
                : "text-primary"
            }`}>
                {senderDisplayName}
            </p>
            {displayContent}
        </div>
    );
};

export const ReplyQuotedMessage = ({ replyTo, onClear, currentUserId, senderName }) => {
    if (!replyTo) return null;

    // Determine the sender name dynamically
    let senderDisplayName = "";
    if (replyTo.senderId === currentUserId) {
        senderDisplayName = "You";
    } else {
        senderDisplayName = senderName || "Unknown";
    }

    let displayContent = null;

    if (replyTo.imageUrl) {
        displayContent = (
            <div className="flex items-center space-x-2">
                <img src={replyTo.imageUrl} alt="Reply preview" className="w-8 h-8 rounded object-cover" />
                <span className="text-sm text-gray-300 truncate max-w-[200px]">📷 Photo</span>
            </div>
        );
    } else if (replyTo.audioUrl) {
        displayContent = (
            <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-gray-700 rounded flex items-center justify-center">
                    <FiMic className="w-4 h-4" />
                </div>
                <span className="text-sm text-gray-300 truncate max-w-[200px]">🎤 Voice message</span>
            </div>
        );
    } else if (replyTo.text) {
        displayContent = (
            <p className="text-sm text-gray-300 truncate max-w-[250px]">
                {replyTo.text}
            </p>
        );
    }

    return (
        <div className="relative mb-2 bg-gray-100 dark:bg-[#2A2A2A] rounded-lg p-2 pl-3 border-l-4 border-primary">
            <button
                onClick={onClear}
                className="absolute top-1 right-1 p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            </button>
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">
                Replying to <span className="font-semibold">{senderDisplayName}</span>
            </p>
            {displayContent}
        </div>
    );
};